import React, {useState,useEffect } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import * as PR from "../../prime-modules/index";
import { useToast } from "../../context/ToastContext";

const DeviceCompatibilty = (props) => {
    const { labels } = useToast();
    const [checked, setChecked] = useState(false);
    const iccid = useSelector(state => state.esim.esimIccid);
    const isAuth = useSelector(state => state.auth.isLoggedIn);

    useEffect(() => {
        if(isAuth && iccid!==""){
            props.setCompatibilityCheck(true);
        }
    }, [iccid, props,isAuth])

    const confirmationMsg = (val) => {
        setChecked(val);
        props.setCompatibilityCheck(val);
    }

    return (
        <>
            {iccid === "" &&
                <section className="compatibility-section">
                    <div className="grid grid-nogutter">
                        <div className="col-12">
                            <div className="compatibility-box">
                                <div className="pt-0">
                                    <div className="field-checkbox">
                                        <PR.Checkbox checked={checked} onChange={e => confirmationMsg(e.checked)} />
                                        <label className="confirmationText">{labels.LBL0008} <Link className="device-link" target="_blank" to="/compatible-devices">{labels.LBL0007}</Link></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            }
        </>
    )
}
export default DeviceCompatibilty;